import React, { ReactNode } from 'react'

import styles from './index.module.css'

type ColorType = 'gray' | 'black'
type AsType = 'span' | 'div' | 'p'
type TextProps = {
  children: ReactNode
  color?: ColorType
  as?: AsType
}

const resolveColor = (color?: ColorType) => {
  switch (color) {
    case 'gray':
      return styles.gray
    case 'black':
      return styles.black
    default:
      return styles.black
  }
}

const Text = ({ color, as, children }: TextProps) => {
  return (
    <>
      {!as && <p className={resolveColor(color)}>{children}</p>}
      {as === 'div' && <div className={resolveColor(color)}>{children}</div>}
      {as === 'span' && <span className={resolveColor(color)}>{children}</span>}
      {as === 'p' && <p className={resolveColor(color)}>{children}</p>}
    </>
  )
}

export default Text
